import { ERROR_TYPE } from '@/features/game-window-integration/helpers/error-mapping';
import { ProviderAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/contracts';
import { runProcessError } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/process-error';
import {
  ExtendableGenericEvents,
  GenericEvents,
} from '@/features/game-window-integration/providers/generic-provider/types';

const eventsRemap: ProviderAdaptor['eventsRemap'] = {
  [GenericEvents.DISMISS_ERROR]: 'resumeAutoSpin',
  [GenericEvents.RELOAD_BALANCE]: 'refreshBalance',
};

export const agsAdaptor: ProviderAdaptor = {
  eventsRemap,

  errorCodesRemap: {
    INSUFFICIENT_FUNDS: ERROR_TYPE.INSUFFICIENT_FUNDS,
    SESSION_EXPIRED: ERROR_TYPE.SESSION_EXPIRED,
    CONNECTION_ERROR: ERROR_TYPE.CONNECTION_LOST,
    GENERIC_ERROR: ERROR_TYPE.GENERIC,
  },

  errorMessages: {},

  adaptInbound: (providerData) => ({ ...providerData }),

  adaptOutbound: (eventToProvider, notify, payload) => {
    const reloadBalanceEvent = eventsRemap[GenericEvents.RELOAD_BALANCE];
    const adaptedPayload =
      eventToProvider === reloadBalanceEvent && payload !== undefined
        ? { balance: payload }
        : payload;

    return {
      type: eventToProvider as unknown as ExtendableGenericEvents,
      source: 'fanduel',
      ...(notify && { stateChangeMessageType: eventToProvider }),
      ...(adaptedPayload !== undefined && { payload: adaptedPayload }),
    };
  },

  processError(error) {
    return runProcessError(error, this.errorCodesRemap, this.errorMessages);
  },
};
